<template>
  <div>
    <arRecap
      v-show="!showDetails"
      :show_age="true"
      :recap_data="units_at_terminal_recap"
      :show_details="onShowDetails"
      :refresh_data="onRefreshData"
      search_type="FULL_AT_TERMINAL"
    />
    <units_list v-show="showDetails" :hide_details="onHideDetails" search_type="FULL_AT_TERMINAL" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import arRecap from "@/components/portal/global/UnitsSummary.vue";
import units_list from "@/components/portal/global/ContainerList.vue";
export default {
  name: "units_at_terminal",
  components: {
    arRecap,
    units_list,
  },
  created() {
    this.$store.dispatch("get_units_at_terminal_recap");
  },
  data() {
    return {
      showDetails: false,
    };
  },
  computed: {
    ...mapGetters(["units_at_terminal_recap"]),
  },
  methods: {
    onHideDetails: function () {
      this.showDetails = false;
    },
    onShowDetails: function (carrier_code, client_id) {
      var payload = { carrier: carrier_code, client_id: client_id };
      this.$store.dispatch("get_units_at_terminal", payload).then(() => {
        this.showDetails = true;
      });
    },
    onRefreshData() {
      this.$store.dispatch("get_units_at_terminal_recap");
    },
  },
};
</script>
